export default {
  lpStaking: {
    minimumAmount: "最低质押：{amount} USDT",
    amountTooLow: "质押数量不能低于 {amount} USDT",
    minimumLoading: "正在获取起押金额",
    minimumFailed: "起押金额暂不可用，请重试",
    confirmationDelayed: "链上确认仍在处理中，可手动刷新质押状态，请勿重复支付",
    statusUnknown: "状态暂不可用",
    refreshStaked: "刷新质押状态",
    paid: "质押成功",
    unpaid: "待支付",
    confirming: "等待链上确认",
    contractPending: "LP 合约待发布，暂不能质押",
    orderInvalid: "订单数据异常，请先核对质押记录",
    walletRequired: "请先连接钱包",
    wrongNetwork: "请切换到正确网络",
    accountChanged: "钱包账户已变化，请重新登录",
    signatureRejected: "已取消钱包操作",
    submitFailed: "提交失败，请重试",
    retryHash: "重新提交交易 Hash",
    hashRetryHint: "交易已发送，请重试提交 Hash，不要重复支付",
    paymentUncertain: "交易状态待核实，请先查看质押记录，勿重复支付",
    orderNumber: "订单号",
    transactionHash: "交易 Hash",
    refreshRecords: "刷新",
    retry: "重试",
    noRecords: "暂无记录",
    recordsFailed: "获取记录失败，请重试",
    stakingIncome: "质押收益",
    loadMore: "加载更多",
    ordersPending: "质押记录暂不可用",
    title: "LP质押",
    staked: "已质押 USDT",
    stakeUsdt: "质押 USDT",
    walletBalance: "钱包 USDT 余额",
    refreshBalance: "刷新钱包余额",
    amount: "质押数量",
    amountPlaceholder: "请输入质押数量",
    amountHint: "选择快捷金额，或手动输入",
    confirm: "确认质押",
    stakingPending: "质押功能待接入",
    dataPending: "数据待接入",
    unavailable: "暂不可用",
    balanceFailed: "获取钱包余额失败，请重试",
    amountRequired: "请输入质押数量",
    amountInvalid: "请输入大于 0 的有效金额",
    insufficient: "钱包 USDT 余额不足",
    records: "我的质押记录",
    ranking: "全网质押排行",
    earnings: "收益记录",
    recordsDescription: "仅展示我的质押记录",
    rankingDescription: "按钱包累计质押金额排序",
    rankingHint: "同一钱包多笔质押合并统计",
    earningsDescription: "查看每笔收益明细",
    back: "返回 LP质押",
    recordLinks: "记录入口",
  },
  确认: "确认",
  取消: "取消",
  选择语言: "选择语言",
  切换语言成功: "切换语言成功",
  首页: "首页",
  采购: "采购",
  团队: "团队",
  "交易进行中,请勿进行其他操作": "交易进行中,请勿进行其他操作",
  资金管理: "资金管理",
  资金明细: "资金明细",
  我的订单: "我的订单",
  订单详情: "订单详情",
  没有更多了: "没有更多了",
  加载中: "加载中",
  代币价格: "代币价格",
  收益概览: "收益概览",
  申购收益: "申购收益",
  分享收益: "分享收益",
  官方网站: "官方网站",
  官网: "官网",
  电报: "电报",
  推特: "推特",
  白皮书: "白皮书",
  申购金额: "申购金额",
  请输入入金金额: "请输入入金金额",
  快捷申购: "快捷申购",
  申购比例: "申购比例",
  赠币数量: "赠币数量",
  立即申购: "立即申购",
  更多: "更多",
  订单: "订单",
  分红中: "分红中",
  已完成: "已完成",
  累计分红: "累计分红",
  申购信息: "申购信息",
  兑换数量: "兑换数量",
  赠币数量: "赠币数量",
  开始时间: "开始时间",
  提现成功: "提现成功",
  确认: "确认",
  订单编号: "订单编号",
  团队数据总览: "团队数据总览",
  我的推广链接: "我的推广链接",
  复制: "复制",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "分享此链接邀请好友加入团队，获取推广奖励",
  团队业绩: "团队业绩",
  当前等级: "当前等级",
  今日收益: "今日收益",
  申购收益: "申购收益",
  分享收益: "分享收益",
  团队用户: "团队用户",
  有效团队: "有效团队",
  有效用户: "有效用户",
  无效团队: "无效团队",
  直推用户: "直推用户",
  有效直推: "有效直推",
  无效直推: "无效直推",
  资产余额数据概览: "资产余额数据概览",
  提现: "提现",
  选中币种: "选中币种",
  请输入入金金额: "请输入入金金额",
  提现数量: "提现数量",
  确认提现: "确认提现",
  资金明细: "资金明细",
  分红收入: "分红收入",
  直推奖励: "直推奖励",
  团队奖励: "团队奖励",
  申购金额: "申购金额",
  兑换数量: "兑换数量",
  赠币数量: "赠币数量",
  开始时间: "开始时间",
  立即申购: "立即申购",
  确认: "确认",
  全部: "全部",
  收入: "收入",
  支出: "支出",
  请输入正确的金额: "请输入正确的金额",
  申购成功: "申购成功",
  申购失败: "申购失败",
  提现失败: "提现失败",
  提现信息: "提现信息",
  提现币种: "提现币种",
  提现数量: "提现数量",
  请选择币种: "请选择币种",
  钱包余额不足: "钱包余额不足",
  余额不足: "余额不足",
  提现手续费: "提现手续费",
  间推奖励: "间推奖励",
  团队奖励: "团队奖励",
  提现失败退还: "提现失败退还",
  ido申购: "ido申购",
  ido申购赠送: "ido申购赠送",
  链式去中心化全球点火网络: "链式去中心化全球点火网络",
  协议永生: "协议永生",
  智能涌现: "智能涌现",
  财富觉醒: "财富觉醒",
  立即进入: "立即进入",
  大区累计业绩: "大区累计业绩",
  小区累计业绩: "小区累计业绩",
  复制成功: "复制成功",
  复制失败: "复制失败",
  暂无数据: "暂无数据",
  当DeFi遇上自主型DAO: "当DeFi遇上自主型DAO",
  历史最高: "历史最高",
  历史最低: "历史最低",
  当前价格: "当前价格",
  采购累计收益: "采购累计收益",
  团队累计收益: "团队累计收益",
  采购金额: "采购金额",
  快捷采购: "快捷采购",
  请输入采购金额: "请输入采购金额",
  采购比例: "采购比例",
  采购信息: "采购信息",
  进行中: "进行中",
  已完成: "已完成",
  累计收益: "累计收益",
  立即采购: "立即采购",
  请输入提现数量: "请输入提现数量",
  提现确认: "提现确认",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除",
  "操作后无法撤销，请谨慎认购": "操作后无法撤销，请谨慎认购",
  我再想想: "我再想想",
  确认提现: "确认提现",
  余额不足: "余额不足",
  直推奖励: "直推奖励",
  团队奖励: "团队奖励",
  提现失败退还: "提现失败退还",
  平级收益: "平级收益",
  每日释放: "每日释放",
  提现TDL: "提现TDL",
  采购失败: "采购失败",
  绑定邀请人: "绑定邀请人",
  采购成功: "采购成功",
  提现比例: "提现比例",
  入金支付说明: "入金支付说明",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "您的实际支付由两部分组成，根据当前支付比例计算",
  支付TDL数量: "支付TDL数量",
  入金数量: "入金数量",
  TDL支付比例: "TDL支付比例",
  "注：支付比例由平台设定，可能随时调整":
    "注：支付比例由平台设定，可能随时调整",
  我知道了: "我知道了",
  支付USDT数量: "支付USDT数量",
  USDT支付比例: "USDT支付比例",
  TDL实时价格: "TDL实时价格",
  请先连接TCC链: "请先连接TCC链",
  收益中: "收益中",
  世界华人的GDT: "世界华人的GDT",
  当Defi遇上自主型DAO: "当Defi遇上自主型DAO",
  提现GGC: "提现GGC",
  支付GGC数量: "支付GGC数量",
  GGC支付比例: "GGC支付比例",
  GGC实时价格: "GGC实时价格",
  兑换: "兑换",
  兑换比例: "兑换比例",
  兑换数量: "兑换数量",
  确认兑换: "确认兑换",
  请输入兑换数量: "请输入兑换数量",
  兑换失败退还: "兑换失败退还",
  兑换GGC: "兑换GGC",
  请输入采购方式: "请输入采购方式",
  余额采购: "余额采购",
  钱包采购: "钱包采购",
  资产余额: "资产余额",
  资产明细: "资产明细",
  余额支付: "余额支付",
  商城划转: "商城划转",
  商城划转GGC: "商城划转GGC",
  采购收益GGC: "采购收益GGC",
  采购方式: "采购方式",
  采购数量: "采购数量",
  链上全球购余额: "链上全球购余额",
  全球购划转USDT: "全球购划转USDT",
  全球购划转GGC: "全球购划转GGC",
  生态合成: "生态合成",
  合成数量: "合成数量",
  合成方式: "合成方式",
  快捷合成: "快捷合成",
  合成比例: "合成比例",
  点击更多更多订单里面还有: "点击更多更多订单里面还有",
  合成信息: "合成信息",
  合成累计收益: "合成累计收益",
  收益统计: "收益统计",
  请输入合成数量: "请输入合成数量",
  请输入合成方式: "请输入合成方式",
  合成说明: "合成说明",
  "50％GGC": "50％GGC",
  "50％GGC价值U": "50％GGC价值U",
  GDT链GGC余额: "GDT链GGC余额",
  GDT链USDT余额: "GDT链USDT余额",
  支付GGC: "支付GGC",
  支付USDT: "支付USDT",
  获取钱包余额失败: "获取钱包余额失败",
  全球购余额: "全球购余额",
  钱包余额: "钱包余额",
  全球购划转余额: "全球购划转余额",
  采购奖励USDT: "采购奖励USDT",
  贸易额度奖励GGC: "贸易额度奖励GGC",
  可变现GGC2数量: "可变现GGC2数量",
  警告: "警告",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数":
    "需配置与GGC价值相等的U合成 , 按双倍GGC数",
  量释放: "量释放",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数量释放":
  "需配置与GGC价值相等的U合成 , 按双倍GGC数量释放",
  该项业务不为中国用户提供任何服务: "该项业务不为中国用户提供任何服务",
  "返回到钱包主页面,即可查阅到生态合成所支付的各项明细(包含：GGC、GDT、USDT)":
    "返回到钱包主页面,即可查阅到生态合成所支付的各项明细(包含：GGC、GDT、USDT)",
};
